<script>
import { mapState } from "vuex";
import DataFilters from "@/components/data-filters.vue";
import EnergyReportForm from "@/components/energy-report-form.vue";
import ExportForm from "@/components/export-form.vue";
import TableSettings from "@/components/table-settings.vue";
import UsageForm from "@/components/usage-form.vue";
import * as api from "@/services/api.js";
import { humanDate, humanTime, timestampSql } from "@/services/datetime.js";

//DEMO
import demoData from "/home/dean/Documents/SRC/PROJECTS/EMERALDGREEN/examples/data/est_51-01_7-17-2024_04-11_2025_5_min.json";

export default {
  name: "usage-view",
  components: {
    DataFilters,
    EnergyReportForm,
    ExportForm,
    TableSettings,
    UsageForm,
  },
  data: () => ({
    activeDate: null,
    activeTrailer: null,
    dates: [],
    dataFilters: {
      loadThreshold: null,
      timeRange: [],
    },
    dataFiltersDialog: false,
    energyReportDialog: false,
    exportDialog: false,
    interval: "",
    isLoading: true,
    message: "",
    period: "",
    tableHeadersMap: {
      //may need different for weekly /monthly usage?
      time: "Time",
      Battery: "Battery",
      Grid: "Grid",
      Load: "Load",
      PV: "Solar",
      SOC: "SOC",
      Generator: "Generator", //not using
    },
    tableHeadersRangeMap: {
      //may need different for weekly /monthly usage?
      time: "Date",
      Load: "Load",
      PV: "Solar",
      Export: "Export",
      Import: "Import",
      Charge: "Battery Charge",
      Discharge: "Battery Discharge",
      Generator: "Generator", //not using
    },
    trailers: [],
    tableSettingsDialog: false,
    usage: [],
    usageDialog: false,
  }),
  computed: {
    ...mapState({
      activeAccount: (state) => state.activeAccount,
      activeAccountTrailers: (state) => state.activeAccountTrailers,
    }),
    cachedDate() {
      //if activeTrailer, find active trailer. if activeTrailer?cacheMeta?....
      //test all scenarios
      if (!this?.activeTrailer && !this.activeDate) {
        return " - ";
      }
      if (this?.activeTrailer) {
        const trailer = this.trailerData.find(
          (t) => t.id === this.activeTrailer
        );

        if (this.interval === "day") {
          let date = null;
          for (const d in trailer.cacheMeta) {
            console.log(d);
            if (trailer.cacheMeta[d]?.mtime) {
              date = trailer.cacheMeta[d].mtime;
              break;
            }
          }
          if (date) {
            return `${humanDate(date)} ${humanTime(date)}`;
          }
        }
        if (trailer && this.activeDate) {
          const date = trailer?.cacheMeta?.[this.activeDate]?.mtime;
          if (date) {
            return `${humanDate(date)} ${humanTime(date)}`;
          }
        }
      }
      return " - ";
    },
    displayedPeriodText() {
      const intervalText = this.interval === "minute" ? "5 min" : "daily";
      let text = "";
      // let text = "Usage: ";
      if (this.isLoading) return text;
      if (this.period === "custom") {
        // text +=  `${new Date(`${this.start} 00:00:00`).toLocaleDateString()}`
        text += `${
          this.dates?.length === 1 || this?.dates?.[0] === this?.dates?.[1]
            ? humanDate(`${this.dates[0]} 00:00:00`, true, false)
            : `${this.dates?.length || "0"}  dates`
        }`;
      }
      if (this.period === "month") {
        // text +=  `${this.start}`
        text += `${this.dates[0]?.split("-").reverse().join("/")}`;
      }
      if (this.period === "range") {
        text += this.dates?.[1]
          ? `${humanDate(
              `${this.dates[0]} 00:00:00`,
              true,
              false
            )} - ${humanDate(`${this.dates[1]} 00:00:00`, true, false)} `
          : humanDate(`${this.dates[0]} 00:00:00`, true, false);
      }
      return `${text}, ${intervalText}`;
    },
    energyBtnMessage() {
      if (this.isLoading) {
        return "Loading data..";
      }
      if (!this.trailers?.length) {
        return "No trailers found";
      }
      if (this.interval !== "minute") {
        // if (this.interval !== "minute" || this.period !== "range") {
        return "Must be in 5min interval reporting";
      }
      return null;
    },
    filtersEnabled() {
      /*
      dataFilters: {
        loadThreshold: null,
        timeRange: [],
      },
      */
      if (!!this.dataFilters?.loadThreshold) return true;
      if (this.dataFilters?.timeRange?.length === 2) return true;
      return false;
    },
    tableData() {
      if (
        !this?.activeTrailer ||
        (this.interval === "minute" && !this.activeDate)
      )
        return [];
      const trailer = [...this.trailerData].find(
        (t) => t.id == this.activeTrailer
      );
      if (!trailer) return [];

      let trailerData;

      //TODO: Test if this is ok regardless of period
      if (this.interval === "minute") {
        const trailerUsage = trailer?.usage?.[this.activeDate];
        trailerData = Object.entries(trailerUsage).map(([time, values]) => {
          return { time, ...values };
        });
      }

      // if (this.period === 'month') {
      if (this.interval === "day") {
        trailerData = Object.entries(trailer.usage).map(([time, values]) => {
          return { time, ...values };
        });
        return trailerData;
      }
      // }

      // console.log(trailer);
      if (!trailer?.usage?.[this?.activeDate]) return [];
      // console.log("has usage");
      trailerData = Object.entries(trailer.usage[this.activeDate]).map(
        ([time, values]) => {
          return { name: trailer.name, time, ...values };
        }
      );

      //filters currently only apply to 5-min interval
      // trailerData should already be returned above in "day" block
      // if (this.interval !== "minute") {
      //   return trailerData;
      // }

      return trailerData;
    },
    tableDataTotals() {
      return [];
      // return this.tableData?.map()
    },
    tableHeaders() {
      //todo, map column label here here
      const defaultDailyHeaders = [
        {
          sortable: true,
          text: "Time",
          value: "time",
        },
        // {
        //   sortable: true,
        //   text: 'Name',
        //   value: 'name',
        // },
        {
          sortable: true,
          text: "Battery",
          value: "Battery",
        },
        {
          sortable: true,
          text: "Grid",
          value: "Grid",
        },
        {
          sortable: true,
          text: "Load",
          value: "Load",
        },
        {
          sortable: true,
          text: "PV",
          value: "PV",
        },
        {
          sortable: true,
          text: "SOC",
          value: "SOC",
        },
        //not using
        // {
        //   sortable: true,
        //   text: 'Generator',
        //   value: 'Generator',
        // },
      ];
      const defaultRangeHeaders = [
        {
          sortable: true,
          text: "Date",
          value: "time",
        },
        // {
        //   sortable: true,
        //   text: 'Name',
        //   value: 'name',
        // },

        {
          sortable: true,
          text: "Load",
          value: "Load",
        },
        {
          sortable: true,
          text: "PV",
          value: "PV",
        },
        {
          sortable: true,
          text: "Export",
          value: "Export",
        },
        {
          sortable: true,
          text: "Import",
          value: "Import",
        },
        {
          sortable: true,
          text: "Charge",
          value: "Charge",
        },

        {
          sortable: true,
          text: "Discharge",
          value: "Discharge",
        },
      ];

      const textMap =
        this.interval === "minute"
          ? this.tableHeadersMap
          : this.tableHeadersRangeMap;
      const defaultHeaders =
        this.interval === "minute" ? defaultDailyHeaders : defaultRangeHeaders;
      return defaultHeaders.map((h) => ({
        ...h,
        text: textMap?.[h?.value] || h.value,
      }));
    },
    trailerData() {
      //map names to trailer ids
      //trailer
      //date
      //if range.. add "week entry of combined totals"
      if (!this.usage || !this.activeAccountTrailers?.length) return [];

      // console.log('trailerData')
      // return [...this.usage]
      // return []
      // const trailers = {}
      const thresholdFilter = this.dataFilters.loadThreshold;
      const hasTimeFilter = this.dataFilters?.timeRange?.length === 2;
      const [startFilter, endFilter] =  hasTimeFilter ?  this.dataFilters?.timeRange : [null, null];
      let sortedWithName = [...this.usage]
        .map((unit) => {
          const trailerData = this.activeAccountTrailers.find(
            (t) => t.id == unit.id
          );
          console.log(unit);
          if (!!thresholdFilter || hasTimeFilter) {
            const usage = {};
            for (let date in unit.usage) {
              if (!usage[date]) {
                usage[date] = {};
              }
              for (let time in unit.usage[date]) {
                if (!!thresholdFilter && Number(unit.usage[date][time]?.Load) < thresholdFilter) {
                  continue
                }
                if (hasTimeFilter &&  (time < startFilter || time > endFilter)) {
                  continue
                }
                usage[date][time] = {...unit.usage[date][time]}
              }
            }
            return { ...unit, usage, name: trailerData?.name || "UNK" };
          } else {
            return { ...unit, name: trailerData?.name || "UNK" };
          }

        })
        .sort((a, b) => a?.name.localeCompare(b?.name));

      return [...sortedWithName];
      // this.activeAccountTrailers
    },
    trailerTabs() {
      // console.log(this.trailerTabs)
      // return []
      // console.log('trailerTabs')
      //maybe all periods.. will see
      // if (this.period === 'month' && this.interval === 'minute') {
      //   return [...this?.trailerData]?.map(t => ({ id: t.id, name: t?.name || 'UNK' }))?.sort((a, b) => a?.name.localeCompare(b?.name)) || []
      // }
      return (
        [...this?.trailerData]
          ?.map((t) => ({ id: t.id, name: t?.name || "UNK" }))
          ?.sort((a, b) => a?.name.localeCompare(b?.name)) || []
      );
    },
    trailerDateTabs() {
      const trailer = this.trailerData.find((t) => t.id == this.activeTrailer);
      if (!trailer) return [];
      if (!trailer?.usage) return [];
      if (this.period === "month") {
        if (this.interval === "minute") {
          return Object.keys(trailer.usage).map((d) => ({
            text: humanDate(`${d} 00:00:00`, true, false),
            value: d,
          }));
        }
        return [];
        // if (this.interval === 'day') {
        //   const monthFixed = this.dates[0].split('-').reverse().join('/')
        //   return [{ text: monthFixed, value: this.dates[0] }]
        // }
      }

      if (this.interval === "day") {
        return [];
        // return Object.keys(trailer?.usage)?.sort((a, b) => a.localeCompare(b)).map(d => ) || []
        return Object.keys(trailer.usage)
          .map((d) => ({
            text: humanDate(`${d} 00:00:00`, true, false),
            value: d,
          }))
          .sort((a, b) => a?.text?.localeCompare(b?.text));
      }

      if (this.interval === "minute") {
        return Object.keys(trailer.usage).map((d) => ({
          text: humanDate(`${d} 00:00:00`, true, false),
          value: d,
        }));
      }
      //  return this.trailerData?.map((t) => ({id: t.id, name: t.name}) )?.sort((a,b) => a?.name.localeCompare(b?.name)) || []
    },
  },
  methods: {
    onSaveFilters(filters) {
      //PICK UP HERE
      console.log(filters);
      this.dataFilters = { ...this.dataFilters, ...filters };
      this.dataFiltersDialog = false;
    },
    testEnergy() {
      console.log("hi");
      let solar = 0;
      this.usage.forEach((x) => {
        for (let date in x.usage) {
          for (let time in x.usage[date]) {
            const val = x.usage?.[date]?.[time]?.PV || 0;
            console.log(`${date} ${time}: ${val}`);
            solar += parseFloat(val);
          }
        }
      });
      console.log(solar);
      //
    },
    onActiveTrailerTabChange() {
      this.$nextTick(() => {
        const selectedExists = this?.trailerDateTabs?.indexOf(
          (t) => t.value === this?.activeDate
        );
        if (!selectedExists) {
          this.activeDate = this?.trailerDateTabs?.[0] || null;
        }
      });
    },

    async onGetUsageFromQueryParams(useCache = "t") {
      //todo, test if all ids exist in active account trailers
      if (!this.activeAccountTrailers?.length) {
        this.$store.dispatch("triggerSnackbar", {
          message: "No trailers found in account state",
          color: "error",
        });
        return;
      }
      //TODO: Move to validation function validate params...
      const requiredParams = ["dates", "interval", "period", "trailers"];
      this.isLoading = true;
      this.message = "";
      for (const req of requiredParams) {
        if (!this.$route?.query?.[req]) {
          this.message = `Missing required paramater: ${req}`;
          this.isLoading = false;
          return;
        }
      }
      let { dates, interval, period, trailers } = this.$route.query;
      dates = dates.split(",");
      if (dates?.length === 1) {
        dates = [dates[0], dates[0]];
      }
      // if (!Array.isArray(dates)) dates = [dates]
      trailers = trailers.split(",");
      // if (!Array.isArray(trailers)) trailers = [trailers]
      const validIntervals = ["minute", "day"];
      if (!validIntervals.includes(interval)) {
        this.message = "Unexpected interval received";
        this.isLoading = false;
        return;
      }
      const validPeriods = ["custom", "range", "month"];
      if (!validPeriods.includes(period)) {
        this.message = "Unexpected period received";
        this.isLoading = false;
        return;
      }

      if (!trailers?.length) {
        console.error("NO UNITS RECEIVED - handle front end");
        this.message = "No trailers received";
        return;
      }

      //TODO, also pass table settings
      const postData = { dates, interval, period, trailers };
      for (let data in postData) {
        this[data] = postData[data];
      }
      postData.labelMap = this.tableHeaders;
      let resp;
      try {
        resp = await api.post(
          `sol/plant-usage${useCache === "f" ? "/f" : ""}`,
          postData
        );
        // resp = demoData

        // console.log(resp)
        //TEMP DOWNLOAD DATA TO FILE
        // const name = 'data.json'
        // const text = JSON.stringify(resp)
        // const a = document.createElement('a')
        // const type = name.split('.').pop()
        // a.href = URL.createObjectURL(new Blob([text], { type: `text/${type === 'txt' ? 'plain' : type}` }))
        // a.download = name
        // a.click()
        if (resp?.status !== "success") {
          throw Error(resp);
        }
        this.usage = resp?.data || [];
        this.$nextTick(() => {
          this.activeDate = this?.trailerDateTabs?.[0]?.value || null;
          this.activeTrailer = this?.trailerTabs?.[0]?.id || null;
        });
      } catch (e) {
        console.error("ERROR GETTING USAGE");
        console.log(e);
      } finally {
        this.isLoading = false;
        if (resp?.message) {
          this.$store.dispatch("triggerSnackbar", {
            message: resp.message,
            color: resp.status,
          });
        }
      }
    },
  },
  async mounted() {
    // console.log(this.$route)
    // console.log(this.$router)
    await this.$nextTick();
    // console.log(this.activeAccountTrailers?.length)
    // if (!this.activeAccountTrailers?.length) {
    // console.log('TODO: fix race condition, fetching usage before account data stored')
    const savedFilters = localStorage.getItem("usageFilters");
    if (savedFilters) {
      this.dataFilters = { ...this.dataFilters, ...JSON.parse(savedFilters) };
    }
    setTimeout(async () => {
      await this.onGetUsageFromQueryParams();
      if (this.$route?.query?.report === "energy") {
        this.energyReportDialog = true;
      }
    }, 1000);
    //probably should be done better elsewhere,
    // but for now. set selected in trailers in state
    // } else {
    // await this.onGetUsageFromQueryParams()
    // }
  },
};
</script>

<template>
  <v-container color="transparent" width="100%" class="usage-container pa-0">
    <v-card color="secondary" height="10px" flat class="dummy-space"
      >&nbsp;</v-card
    >
    <v-card
      color="primary"
      class="filter-card text-left mt-1"
      style="width: 100%"
    >
      <v-card-title>
        <v-btn dark outlined text to="/" class="align-self-start">
          <v-icon left>mdi-chevron-left</v-icon>
          <span class="font-weight-bold">TRAILERS</span></v-btn
        >
        <!-- <v-btn small elevation="" color="red" @click="testEnergy">test</v-btn> -->

        <v-spacer></v-spacer>
        <v-dialog v-model="dataFiltersDialog" max-width="800" width="90vw">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :color="filtersEnabled ? 'warning' : 'secondary'"
              :disabled="isLoading || interval !== 'minute'"
              icon
              class="align-self-start mr-4"
              ><v-icon>{{
                `mdi-filter${
                  interval === "minute" && filtersEnabled ? "-check" : ""
                }`
              }}</v-icon></v-btn
            >
          </template>
          <data-filters
            v-if="dataFiltersDialog"
            :dataFilters="dataFilters"
            @close="dataFiltersDialog = false"
            @saveFilters="onSaveFilters"
          ></data-filters>
        </v-dialog>
        <v-dialog v-model="tableSettingsDialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="secondary"
              :disabled="isLoading"
              icon
              class="align-self-start mr-4"
              ><v-icon>mdi-table-cog</v-icon></v-btn
            >
          </template>
          <table-settings
            :fields="
              this.interval === 'minute'
                ? { ...tableHeadersMap }
                : { ...tableHeadersRangeMap }
            "
            @close="tableSettingsDialog = false"
          />
        </v-dialog>
        <v-sheet color="transparent" class="d-flex flex-column ml-auto">
          <v-dialog v-model="exportDialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="secondary"
                :disabled="!tableData?.length"
                class="primary--text"
              >
                <v-icon left>mdi-table-arrow-right</v-icon>
                <span class="font-weight-bold" style="min-width: 140px"
                  >DATA EXPORT</span
                >
              </v-btn>
            </template>
            <export-form
              :key="exportDialog"
              :data="trailerData"
              :fields="tableHeaders"
              :interval="interval"
              :period="period"
              @close="exportDialog = false"
            />
          </v-dialog>
          <v-tooltip color="primary" hover top :disabled="!energyBtnMessage">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-dialog
                  v-model="energyReportDialog"
                  width="100%"
                  max-width="1000"
                  scrollable
                  style="overflow-x: hidden"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="secondary"
                      :disabled="!!energyBtnMessage"
                      class="mt-2"
                      style="width: 192px"
                      ><v-icon color="primary" left>mdi-chart-arc</v-icon
                      ><span
                        class="primary--text font-weight-bold"
                        style="min-width: 140px"
                        >ENERGY REPORT</span
                      ></v-btn
                    >
                  </template>
                  <energy-report-form
                    v-if="energyReportDialog"
                    :selectedTrailers="trailerData"
                    :dates="dates"
                    :period="period"
                    @close="energyReportDialog = false"
                  />
                </v-dialog>
              </div>
            </template>
            <span class="font-weight-bold">{{ energyBtnMessage }}</span>
          </v-tooltip>
        </v-sheet>
      </v-card-title>
      <v-card-text class="text-left pb-0">
        <p
          v-if="message"
          class="secondary error--text font-weight-bold rounded pa-4"
        >
          <v-icon color="red" left>mdi-alert</v-icon> {{ message }}
        </p>
        <v-sheet
          class="d-flex align-end flex-row flex-wrap justify-space-between transparent"
        >
          <v-sheet color="transparent" class="d-flex flex-row align-center">
            <!-- <v-tooltip color="primary" hover top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    color="secondary"
                    icon
                    :loading="isLoading"
                    @click="onGetUsageFromQueryParams('f')"
                    class="mr-2"
                    ><v-icon>mdi-refresh</v-icon></v-btn
                  >
                </template>
                <span class="font-weight-bold px-2">REFRESH CACHED DATA</span>
              </v-tooltip> -->
            <v-dialog v-model="usageDialog" max-width="400">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" class="px-0"
                  ><v-icon color="secondary">mdi-calendar</v-icon
                  ><v-icon color="secondary">mdi-menu-down</v-icon></v-btn
                >
              </template>
              <usage-form
                :selectedTrailers="trailerData"
                @close="usageDialog = false"
              />
            </v-dialog>
            <span
              class="align-center text-center text-body-1 text-uppercase secondary--text text-no-wrap font-weight-bold mb-0"
            >
              {{ displayedPeriodText || "" }}
            </span>
          </v-sheet>

          <p
            class="text-body-1 text-uppercase text-no-wrap secondary--text font-weight-bold mb-0 mt-auto pl-3"
          >
            Results: {{ `${tableData?.length || 0}` }}
            {{
              tableData?.length > 0
                ? `(${((tableData.length * 5) / 60).toFixed(2)} hrs)`
                : ""
            }}
          </p>
        </v-sheet>
      </v-card-text>
      <v-card-actions class="d-flex flex-column align-start">
        <v-progress-linear v-if="isLoading" color="secondary" indeterminate>
        </v-progress-linear>
        <v-tabs
          v-show="!isLoading && trailerTabs.length"
          v-model="activeTrailer"
          color="primary"
          show-arrows
          slider-color="primary"
          @change="onActiveTrailerTabChange"
          class="rounded"
        >
          <v-tab
            v-for="tab in trailerTabs"
            :key="tab.id"
            :href="'#' + tab.id"
            ripple
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
        <v-tabs
          v-if="!isLoading && trailerDateTabs?.length"
          v-model="activeDate"
          color="primary"
          show-arrows
          slider-color="primary"
          class="rounded my-1"
          style="overflow: hidden"
        >
          <v-tab
            v-for="tab in trailerDateTabs"
            :key="tab.value"
            :href="'#' + tab.value"
            ripple
            >{{ tab.text }}</v-tab
          >
        </v-tabs>
      </v-card-actions>
    </v-card>
    <v-card color="primary" class="mt-1 mb-16 mx-1">
      <v-card-text>
        <!-- <p v-if="!this?.trailerTabs?.length" class="secondary--text font-weight-bold">No trailers found.</p>
        <p v-else-if="!this.start" class="secondary--text font-weight-bold">No date provided</p> -->
        <!-- v-else -->
        <v-slide-x-reverse-transition mode="out-in">
          <v-sheet
            v-if="!isLoading"
            :key="this.activeDate + this.activeTrailer"
            color="primary"
            style="overflow: hidden"
          >
            <!-- <p class="secondary--text font-weight-bold text-left mb-0">
              cached:
            </p> -->
            <v-sheet color="secondary">
              <v-data-table
                :headers="tableHeaders"
                :items="tableData"
                :items-per-page="-1"
                item-key="time"
                no-data-text="No data found"
                ref="usageTable"
                class="elevation-1"
              >
                <template v-slot:header></template>

                <template
                  v-if="tableDataTotals?.length"
                  v-slot:body.prepend="{ headers }"
                >
                  <tr>
                    <td
                      v-for="header in headers"
                      :key="header.value"
                      class="text-start"
                    >
                      {{ tableData?.[0]?.[header.value] }}
                    </td>
                  </tr>
                </template>
                <template v-slot:top> </template>
              </v-data-table>
            </v-sheet>
          </v-sheet>
        </v-slide-x-reverse-transition>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style scoped>
.usage-container {
  max-width: 1400px;
}

.dummy-space {
  position: sticky;
  top: 0px;
  z-index: 11;
}

.filter-card {
  position: sticky;
  top: 55px;
  z-index: 11;
}

>>> .v-tabs-slider-wrapper {
  bottom: 2px;
}
</style>
